import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from '../../../api/axiosInstance';
import endpoints from '../../../api/endpoints';

interface Article {
  LibelleArticle: string;
  QteCommandee: number;
  QteLivree: number;
  QTE_RESTANTE: number;
}

interface ChauffeurCamion {
  FullName: string;
  PhoneNumber: string;
  NumeroCamion: string;
}

interface Camion {
  longitude: string;
  latitude: string;
  data: string;
}

interface OrderDetails {
  NumeroCommande: string;
  NumeroClient: string | null;
  Articles: Article[];
  ChauffeurCamions: ChauffeurCamion[];
  Camions: Camion[];
}

export interface PreOrder {
  ClientCode: string;
  ClientName: string;
  SiteVenteId: string;
  SiteExpId: string;
  StatutCode: string;
  StatutId: number;
  Totale: number;
  Articles: ArticlePreOrder[];
}

export interface ArticlePreOrder {
  Id: number;
  RefArticle: string;
  LibelleArticle: string;
  Qte: number;
  Prix: number;
  Unite: string;
  Commentaire: string;
  TypeArticle: string;
}

interface ApiState {
  data: OrderDetails | null;
  loading: boolean;
  error: string | null;
  selectedOrder: string | null;
  dataPreOrder: PreOrder | null;
  loadingPreOrder: boolean;
  errorPreOrder: string | null;
  selectedPreOrder: string | null;
}

const initialState: ApiState = {
  data: null,
  loading: false,
  error: null,
  selectedOrder: null,
  dataPreOrder: null,
  loadingPreOrder: false,
  errorPreOrder: null,
  selectedPreOrder: null,
};





export const fetchOrderDetails = createAsyncThunk(
  'api/fetchOrderDetails',
  async (orderNumber: string) => {
    const response = await axiosInstance.get(
      endpoints.commandes.detailCommandeParClient + `${orderNumber}`
    );
    return response.data;
  }
);

export const fetchPreOrderDetails = createAsyncThunk(
  'api/fetchPreOrderDetails',
  async (orderNumber: string) => {
    const response = await axiosInstance.get(
      endpoints.preOrders.preOrderDetail + 
        `${orderNumber}`
    );
    
    return response.data;
  }
);

const detailOrderSlice = createSlice({
  name: 'detailOrder',
  initialState,
  reducers: {
    selectOrder: (state, action: PayloadAction<string | null>) => {
      state.selectedOrder = action.payload;
      if (action.payload === null) {
        state.data = null;
      }
    },
    selectPreOrder: (state, action: PayloadAction<string | null>) => {
      state.selectedPreOrder = action.payload;
      if (action.payload === null) {
        state.dataPreOrder = null;
      }
    },
    clearOrderDetails: (state) => {
      state.data = null;
      state.selectedOrder = null;
    },
    clearPreOrderDetails: (state) => {
      state.dataPreOrder = null;
      state.selectedPreOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchOrderDetails.fulfilled,
        (state, action: PayloadAction<OrderDetails>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch order details';
      })
      .addCase(fetchPreOrderDetails.pending, (state) => {
        state.loadingPreOrder = true;
        state.errorPreOrder = null;
      })
      .addCase(
        fetchPreOrderDetails.fulfilled,
        (state, action: PayloadAction<PreOrder>) => {
          state.loadingPreOrder = false;
          state.dataPreOrder = action.payload;
        }
      )
      .addCase(fetchPreOrderDetails.rejected, (state, action) => {
        state.loadingPreOrder = false;
        state.errorPreOrder =
          action.error.message || 'Failed to fetch order details';
      });
  },
});

export const {
  selectOrder,
  selectPreOrder,
  clearOrderDetails,
  clearPreOrderDetails,
} = detailOrderSlice.actions;

export default detailOrderSlice.reducer;
